// StockReducer.js

import * as types from './stockStatusActionTypes';

const initialState = {
  stockStatusData: null,
  stockStatusList: null,
  stockStatusHistorySortData: null,
  error: {
    type: null,
    data: null,
  },
  createStockStatusData: null,
  createStockStatusError: null,
  updateStockStatusData: null,
  updateStockStatusError: null,
  deleteStockStatusData: null,
  deleteStockStatusError: null,
};

export const stockStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Stock Status Data
    case types.GET_STOCK_STATUS_DATA:
      return {
        ...state,
        stockStatusData: action.payload ? { ...action.payload } : null,
        stockStatusList: action.payload?.StockStatusList ? [...action.payload.StockStatusList] : [],
      };

    case types.GET_STOCK_STATUS_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_STOCK_STATUS_ERROR, 
          data: action.payload,
        },
      };

    // Sorting Stock History Data
    case types.SET_STOCK_HISTORY_SORT_DATA:
      return {
        ...state,
        stockStatusHistorySortData: {
          orderBy: action.payload.orderBy,
          order: action.payload.order,
        },
      };

    // Create Stock Status
    case types.CREATE_STOCK_STATUS_REQUEST:
      return {
        ...state,
        createStockStatusError: null,
      };

    case types.CREATE_STOCK_STATUS_DATA:
      return {
        ...state,
        createStockStatusData: action.payload,
        createStockStatusError: null,
      };

    case types.CREATE_STOCK_STATUS_ERROR:
      return {
        ...state,
        createStockStatusData: null,
        createStockStatusError: action.payload,
      };

    // Update Stock Status
    case types.UPDATE_STOCK_STATUS_REQUEST:
      return {
        ...state,
        updateStockStatusError: null,
      };

    case types.UPDATE_STOCK_STATUS_DATA:
      return {
        ...state,
        updateStockStatusData: action.payload,
        updateStockStatusError: null,
      };

    case types.UPDATE_STOCK_STATUS_ERROR:
      return {
        ...state,
        updateStockStatusData: null,
        updateStockStatusError: action.payload,
      };

    // Delete Stock Status
    case types.DELETE_STOCK_STATUS_REQUEST:
      return {
        ...state,
        deleteStockStatusError: null,
      };

    case types.DELETE_STOCK_STATUS_DATA:
      return {
        ...state,
        deleteStockStatusData: action.payload,
        deleteStockStatusError: null,
      };

    case types.DELETE_STOCK_STATUS_ERROR:
      return {
        ...state,
        deleteStockStatusData: null,
        deleteStockStatusError: action.payload,
      };

    default:
      return state;
  }
};
